import { Component, input, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';

const MAX_LENGTH = 2;

@Component({
    selector: 'lib-time-picker',
    imports: [
        MatOptionModule,
        FormsModule,
        MatMenuModule,
        MatFormFieldModule,
        ReactiveFormsModule
    ],
    templateUrl: './time-picker.component.html',
    styleUrl: './time-picker.component.scss'
})
export class TimePickerComponent {

    @Input() formGroup!: FormGroup;
    label = input<string>('');
    disabled = input<boolean>(false);

    preventPlusMinus(event: KeyboardEvent): void {
        if (event.key === '-' || event.key === '+') {
            event.preventDefault();
        }
    }

    onTimeBlur(event: Event, key: string): void {
        const currentInput = event.target as HTMLInputElement;
        let { value } = currentInput;

        if (value.length === 1) {
            currentInput.value = `0${value}`;
        }

        this.formGroup.get(key)?.setValue(currentInput.value);
    }

    onTimeChange(event: Event, key: string): void {
        const currentInput = event.target as HTMLInputElement;
        const { value } = currentInput;

        if (value.length > MAX_LENGTH) {
            currentInput.value = value.slice(0, MAX_LENGTH);
        }

        this.formGroup.get(key)?.setValue(currentInput.value);
    }
}